var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.224 6.944a2.95 2.95 0 00-2.164-.942 2.95 2.95 0 00-2.159.936l-.002.002c-1.2 1.252-1.2 3.292-.008 4.548L13.839 25.06c.542.579 1.311.94 2.164.94s1.622-.361 2.162-.939l.002-.002 12.94-13.568a3.281 3.281 0 00.892-2.255v-.034c0-.875-.341-1.671-.898-2.261l.002.002C30.561 6.362 29.791 6 28.937 6s-1.624.362-2.164.941l-.002.002-10.772 11.296L5.223 6.943z"
  })));
}
export default SvgDropArrow;